import React from 'react';
import {Col} from 'reactstrap';

const sponsor = (props) => {
    return(
        <Col xs='6' md='2'>
            <div className="sponsor">
                <a href={props.url} target="blank"><img src={props.img} alt={props.name} /></a>
            </div>
        </Col>
    )
};

export default sponsor;


// WEBPACK FOOTER //
// ./src/components/Sponsors/Sponsor/Sponsor.js